<!-- <ng-container *ngIf="conditionResource$ | async as conditionResource"> -->
<ng-container *ngIf="layoutResource$ | async as layoutResource">
  <ng-container *ngIf="transportModeResource$ | async as transportModeResource">
    <div id="ch-ggs-web-suite-content">
      <div class="container">
        <h1>{{ transportModeResource['HeadingTitle'] }}</h1>

        <hazmatsuite-next-transport-mode-cards
          [cards]="[
            {
              title: transportModeResource['CardRoadTitle'],
              text: transportModeResource['CardRoadText'],
              buttonText: transportModeResource['CardRoadButton'],
              transportMode: transportModes.Road
            },
            {
              title: transportModeResource['CardRailTitle'],
              text: transportModeResource['CardRailText'],
              buttonText: transportModeResource['CardRailButton'],
              transportMode: transportModes.Rail
            },
            {
              title: transportModeResource['CardSeaTitle'],
              text: transportModeResource['CardSeaText'],
              buttonText: transportModeResource['CardSeaButton'],
              transportMode: transportModes.Sea
            },
            {
              title: transportModeResource['CardAirTitle'],
              text: transportModeResource['CardAirText'],
              buttonText: transportModeResource['CardAirButton'],
              transportMode: transportModes.Air
            }
          ]"
          (selected)="selectTransportMode($event)"
        ></hazmatsuite-next-transport-mode-cards>

        <div class="row">
          <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <h2>
              {{
                layoutResource['ToolTitleWhy']
                  | stringReplace: layoutResource['ToolNameEasyDGD']
              }}
            </h2>
            <div
              [innerHTML]="layoutResource['ToolTextEasyDGD1'] | safeHtml"
            ></div>
            <h4>
              {{
                layoutResource['ToolTitleHowDoesItWork']
                  | stringReplace: layoutResource['ToolNameEasyDGD']
              }}
            </h4>
            <div
              [innerHTML]="layoutResource['ToolTextEasyDGD2'] | safeHtml"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <hazmatsuite-next-modal
      [title]="transportModeResource['ModalTrainingRequiredTitle']"
      [showModal]="showConfirmationModal"
      [confirmButtonLabel]="layoutResource['ModalButtonConfirm']"
      modalSize="md"
      (closeModal)="showConfirmationModal = false"
      (confirm)="setTransportMode(transportModes.Air)"
    >
      <p
        [innerHTML]="
          transportModeResource['ModalTrainingRequiredText'] | safeHtml
        "
      ></p>
    </hazmatsuite-next-modal>
  </ng-container>
</ng-container>
<!-- </ng-container> -->
